import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function AdminSettings() {
  const [commission, setCommission] = useState({ percent: 20, min_withdrawal: 500 });
  const [site, setSite] = useState({ name: "VIRIKS", tagline: "" });

  useEffect(() => {
    api.get("/settings/commission").then(({ data }) => data.value && setCommission(data.value));
    api.get("/settings/site").then(({ data }) => data.value && setSite(data.value));
  }, []);

  const saveCommission = async () => { await api.put("/settings/commission", { value: { percent: Number(commission.percent), min_withdrawal: Number(commission.min_withdrawal) } }); toast.success("Commission settings saved"); };
  const saveSite = async () => { await api.put("/settings/site", { value: site }); toast.success("Site settings saved"); };

  return (
    <div data-testid="admin-settings">
      <PageHeader title="Platform Settings" subtitle="Configure commission & site details" />
      <div className="grid lg:grid-cols-2 gap-6">
        <div className="bg-white border border-border rounded-lg p-6">
          <h2 className="font-heading font-bold text-navy mb-4">Commission Engine</h2>
          <div className="space-y-4">
            <div><Label>Default Commission (%)</Label><Input type="number" value={commission.percent} onChange={(e) => setCommission({ ...commission, percent: e.target.value })} data-testid="commission-percent" /></div>
            <div><Label>Minimum Withdrawal (₹)</Label><Input type="number" value={commission.min_withdrawal} onChange={(e) => setCommission({ ...commission, min_withdrawal: e.target.value })} data-testid="min-withdrawal" /></div>
            <Button className="viriks-navy text-white" onClick={saveCommission} data-testid="save-commission">Save</Button>
          </div>
        </div>
        <div className="bg-white border border-border rounded-lg p-6">
          <h2 className="font-heading font-bold text-navy mb-4">Site Details</h2>
          <div className="space-y-4">
            <div><Label>Site Name</Label><Input value={site.name} onChange={(e) => setSite({ ...site, name: e.target.value })} /></div>
            <div><Label>Tagline</Label><Input value={site.tagline} onChange={(e) => setSite({ ...site, tagline: e.target.value })} /></div>
            <Button className="viriks-navy text-white" onClick={saveSite} data-testid="save-site">Save</Button>
          </div>
        </div>
      </div>
    </div>
  );
}
